module.exports = __webpack_public_path__ + "static/media/demo100Small.5e3bc3d6.mp4";